import {Component, OnInit, OnDestroy, AfterViewInit} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import {Router} from '@angular/router';
import {StorageService} from '../../../../Services/storage.service';
import {HttpErrorResponse} from '@angular/common/http';
import {AppConfigService} from '../../../../Services/app-config.service';
import {Observable} from 'rxjs';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {PagerStateService} from '../../../../Services/pager-state.service';
import {NgbpaginationConfigService} from '../../../../Services/ngbpagination-config.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {Title} from '@angular/platform-browser';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-banks-list',
  templateUrl: './bank-list.component.html',
  styleUrls: ['./bank-list.component.css'],
  standalone: false
})

export class BankListComponent extends ListPageBase implements AfterViewInit, OnDestroy, OnInit, AfterViewInit {

  constructor(private table: DataService,
              private toastr: BsToastService,
              private storage: StorageService,
              private dateFilter: DateFilterService,
              private ngbConfig: NgbPaginationConfig,
              private pagerConfig: NgbpaginationConfigService,
              private titleService: Title
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  BankCount = 0;
  accounts$: Observable<any>;
  accountCount = 0;
  companyCount = 0;
  currencyCount = 0;
  isLoaded = false;
  vm: any = [];




  ngOnInit() {
    this.restorePagerState();
    this.vm.list = [];
    this.getData();
  }

  ngAfterViewInit() {
    this.titleService.setTitle($localize`:Bank List @@bankList:Bank List`);
  }

  ngOnDestroy(): void {
    // no legacy datatable resources to clean
  }


  getData() {
    let paramString = '?search=' + ((this.vm.searchTerm) ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + ((this.vm.fromDate) ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + ((this.vm.toDate) ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + ((this.page !== 0) ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('bank', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.BankCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      },
      () => {
      }
    );
  }

  // getCounts() {
  //   this.table.getApiListData('account', '?state=active&pageNumber=0&pageSize=999999').pipe(take(1)).subscribe(result => {
  //     this.accountCount = result.totalRecords;
  //   });
  //   this.table.getApiListData('company', '?state=active&pageNumber=0&pageSize=999999').pipe(take(1)).subscribe(result => {
  //     this.companyCount = result.totalRecords;
  //   });
  //   this.table.getApiListData('currency', '?state=active&pageNumber=0&pageSize=999999').pipe(take(1)).subscribe(result => {
  //     this.currencyCount = result.totalRecords;
  //   });
  // }

  onNavigate(aID: string) {
    this.router.navigate(['admin/bank-form', {id: aID}]);
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString = '?search=' + ((this.vm.searchTerm) ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + ((this.vm.fromDate) ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + ((this.vm.toDate) ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + ((this.page !== 0) ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('bank', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      },
      () => {
      }
    );
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }


}

